<ng-container *ngIf="Resultados">
    <!--PARTE PARA HOME Y NOMBRE DEL COLABORADOR (CARPETA)-->
    <div fxLayout="column" fxLayoutAlign="center start">
        <div fxLayout="row" fxLayoutAlign="start center">
            <ng-container *ngIf="carpetaActual == ''">
                <mat-icon class="secondary-text s-24">home</mat-icon>
                <mat-icon class="secondary-text s-30">chevron_right</mat-icon>
                <span (click)="btn_inicio('')" class="botonNav"><h2>{{'FILEMANAGER.LISTA.TITULOSENC.BT' | translate}}</h2></span>
            </ng-container>
            <ng-container *ngIf="carpetaActual != ''">
                <!--<mat-icon (click)="getListaArchivos('')" class="secondary-text s-24 botonNav">home</mat-icon>
                <mat-icon class="secondary-text s-30">chevron_right</mat-icon>
                <span (click)="getListaArchivos('')" class="botonNav"><h2>{{'FILEMANAGER.LISTA.TITULOSENC.BT' | translate}}</h2></span>
                <mat-icon class="secondary-text s-30">chevron_right</mat-icon>
                <span class=""><h2>{{nombreColaborador}}</h2></span>-->
                <mat-icon (click)="btn_inicio()" class="secondary-text s-24 botonNav">home</mat-icon>
                <mat-icon class="secondary-text s-30">chevron_right</mat-icon>
                <span (click)="btn_inicio('')" class="botonNav"><h2>{{'FILEMANAGER.LISTA.TITULOSENC.BT' | translate}}</h2></span>
                <mat-icon class="secondary-text s-30">chevron_right</mat-icon>
                <span class=""><h2>{{nombreColaborador}}</h2></span>
            </ng-container>
        </div>
    </div>

    <ng-container *ngIf="listaArchivosEmpresa && statusTable && carga_completa">
        <div fxLayout="column" fxLayoutAlign="space-around stretch">
            <mat-form-field appearance="outline">
                <mat-label>{{'WIZARD.SEARCH' | translate}}</mat-label>
                <input matInput (keyup)="applyFilter($event)">
                <mat-icon matSuffix class="disabled-text">search</mat-icon>
            </mat-form-field>
        </div>
    </ng-container>

    <mat-table *ngIf="listaArchivosEmpresa && statusTable && carga_completa && !noInformation" class="mat-elevation-z3 p-20" [dataSource]="dataSource" [@animateStagger]="{value:'50'}">

        <ng-container matColumnDef="icono">
            <mat-header-cell *matHeaderCellDef fxFlex="64px"></mat-header-cell>
            <mat-cell *matCellDef="let fila" fxFlex="64px">
                <mat-icon class="type-icon">folder</mat-icon>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="nombre">
            <mat-header-cell *matHeaderCellDef>
                <h2><b class="word">{{'FILEMANAGER.LISTA.TITULOSENC.NOMBRE' | translate}}</b></h2>
            </mat-header-cell>
            <mat-cell *matCellDef="let fila">
                <ng-container>
                    <b class="botonNav" (click)="getListaArchivos(fila._id,fila.NameUser,fila.Institute)" *ngIf="!bloquearTabla">{{fila.NameUser}}</b>
                    <b class="botonNav word" *ngIf="bloquearTabla">{{fila.NameUser}} </b>
                </ng-container>
                <ng-container *ngIf="!'folder'">
                    {{fila.nombreArchivo}}
                </ng-container>
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="nombresColumnas"></mat-header-row>
        <mat-row *matRowDef="let fila; columns: nombresColumnas;" matRipple [@animate]="{value:'*',params:{y:'100%'}}">
        </mat-row>
    </mat-table>

    <mat-table *ngIf="listaArchivos && !statusTable" class="mat-elevation-z3 p-20" [dataSource]="listaArchivos.evidencias" [@animateStagger]="{value:'50'}">

        <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef>
                <h2><b class="word">{{'FILEMANAGER.LISTA.TITULOSENC.ARCH' | translate}}</b></h2>
            </mat-header-cell>
            <mat-cell *matCellDef="let filaArch" style="padding-right: 25px;">
                <ng-container>
                    {{filaArch.nombreArchivo}}
                </ng-container>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="date">

            <mat-header-cell *matHeaderCellDef>
                <h2><b class="word">{{'FILEMANAGER.LISTA.TITULOSENC.DATE' | translate}}</b></h2>
            </mat-header-cell>
            <mat-cell *matCellDef="let filaArch">
                <ng-container>
                    {{filaArch.updatedAt}}
                </ng-container>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="act">
            <mat-header-cell *matHeaderCellDef>
                <h2><b class="word">{{'FILEMANAGER.LISTA.TITULOSENC.ACT' | translate}}</b></h2>
            </mat-header-cell>
            <mat-cell *matCellDef="let filaArch">

                <a mat-mini-fab color="primary" matTooltip="{{'FILEMANAGER.LISTA.TOOLTIP.DESCARGA' | translate}}" class="mr-20" href="http://{{urlServidor}}/surveyadministrator/backend/{{filaArch.rutaArchivo + filaArch.nombreArchivo}}" target="_blank" download>
                    <mat-icon>cloud_download</mat-icon>
                </a>

                <button *ngIf="puedeBorrar" mat-mini-fab matTooltip="{{'FILEMANAGER.LISTA.TOOLTIP.DELETE' | translate}}" (click)="borraArchivo(filaArch._id)" color="warn">
                <mat-icon>delete_forever</mat-icon>
            </button>
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="nombresColumnasheader"></mat-header-row>
        <mat-row *matRowDef="let filaArch; columns: nombresColumnasCont;" matRipple [@animate]="{value:'*',params:{y:'100%'}}">
        </mat-row>
    </mat-table>

</ng-container>

<ng-container *ngIf="!Resultados && Cargando">
    <br>
    <div class="roundEdg primary mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="space-between center" style="margin-top: 5%; margin-bottom: 3%;">
        <h2>{{'MODALES.EXPEDIENTES.Resultados' | translate}}</h2>
        <mat-icon class="ml-20 s-40">error_outline</mat-icon>
    </div>
</ng-container>

<ng-container *ngIf="Cargando && noInformation">
    <br>
    <div class="roundEdg primary mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="space-between center" style="margin-top: 5%; margin-bottom: 3%;">
        <h2>{{'WIZARD.DatosColaboradores.NOFOUND' | translate}}</h2>
        <mat-icon class="ml-20 s-40">error_outline</mat-icon>
    </div>
</ng-container>
<!--<ng-container *ngIf="Cargando && NoshowTable">
    <br>
    <div class="roundEdg primary mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="space-between center" style="margin-top: 5%; margin-bottom: 3%;">
        <h2>Aún no cuenta con resultados</h2>
        <mat-icon class="ml-20 s-40">error_outline</mat-icon>
    </div>
</ng-container>-->
<ng-container *ngIf="!Cargando ">
    <div fxLayout="column" fxLayoutAlign="space-between center">
        <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
        <h1>{{'MODALES.EXPEDIENTES.CARGANDO_COLABORADORES' | translate}}</h1>
    </div>
</ng-container>